import $ from "jquery";

export default function (to, from, next) {
    next()

    if (window.innerWidth < 1170) {
        $("body").toggleClass("mini-sidebar", true);
        $("body").toggleClass("navbar-brand", false);
        $("#topbarlongname").css('display','none');
    }
    else
    {
        $("#topbarnavbar").toggleClass("navbar-expand-md", true);
        $("#navbarcontainer").toggleClass("navbar-expand-md", true);
    }

    if (window.innerWidth < 768) {
        $("body").toggleClass("show-sidebar", false);
        $(".nav-toggler i").addClass("ti-menu")
    }    
}